import { Components } from "@thisgorilla/primate-ds";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { ROUTES } from "../../../../../utills/routes";
import { DefaultPostProps } from "./DefaultPost";

const attachmentsList: DefaultPostProps.AttachmentsList = [
  { label: "Add media", iconType: "Image", type: "Image" },
  { label: "Add videos", iconType: "VideoNew", type: "Video" },
  { label: "Add audio", iconType: "AudioNew", type: "Audio" },
  { label: "Create a poll", iconType: "Poll", type: "Poll" },
  { label: "Create a rating", iconType: "Slider", type: "Slider" },
];

export const Attachments = ({
  openCreatePostModal,
}: DefaultPostProps.OpenPostModal) => {
  const navigate = useNavigate();
  return (
    <Container className="default-post-attachments">
      {attachmentsList.map(({ iconType, label, type }, index) => (
        <Components.Tooltip type="label" label={label} key={index}>
          <Components.IconButton
            iconType={iconType}
            kind="Secondary"
            size="Medium"
            onClick={() => openCreatePostModal(type)}
            disabled={false}
          />
        </Components.Tooltip>
      ))}
      <Components.Tooltip type="label" label="Write an article">
        <Components.IconButton
          iconType={"FileText"}
          kind="Secondary"
          size="Medium"
          onClick={() => navigate(ROUTES.article)}
          disabled={false}
        />
      </Components.Tooltip>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;
